module.exports = __webpack_public_path__ + "img/beijingtu (2).1d747a86.png";